import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {UIWLeaderboardCTAController} from './UIWLeaderboardCTAController'
import {uiManager} from '../EntryHomepage'

export class UIDLeaderboardCTAController extends UIWLeaderboardCTAController {
    // eslint-disable-next-line class-methods-use-this
    protected actionBaseGame() {
        uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic4P)
    }

    // eslint-disable-next-line class-methods-use-this
    protected action1v1() {
        uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedClassic1v1)
    }

    // eslint-disable-next-line class-methods-use-this
    protected actionCK() {
        uiManager.matchmakingController.sendFindGameMessageToServer(MatchmakingMatchTypes.RankedCitiesAndKnights4P)
    }
}
